import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Badge, ColumnsPickerLite } from "@similarweb/ui-components";
import { getColumnsPickerLiteProps } from "app/pages/keyword-analysis/common/UtilityFunctions";
import { FiltersContainer, Right, BooleanSearchContainer, SearchContainer } from "./StyledComponents";
import { DefaultFetchService } from "app/services/fetchService";
import { BooleanSearchUtilityWrapper } from "app/pages/website-analysis/traffic-sources/search/BooleanSearchUtilityWrapper";
import { booleanSearchToObject } from "app/pages/website-analysis/traffic-sources/search/booleanSearchUtility";
import { BrandedNonBrandedFilter } from "app/pages/website-analysis/traffic-sources/search/components/filters/BrandedNonBrandedFilter";
import { EBrandedNonBrandedValues } from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageTypes";
import {
    IncludeNewKeywordsFilterView,
    IncludeTrendingKeywordsFilterView,
} from "app/pages/website-analysis/traffic-sources/search/components/filters/CheckboxFilter";
import { BasicDurations } from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { swSettings } from "app/common/services/swSettings";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

const EXCEL_ENDPOINT = "widgetApi/IndustryAnalysisTopKeywords/SearchKeywordsAbb/Excel";

export const TableTop = ({
    tableColumns,
    onClickToggleColumns,
    onFilterChange,
    params,
    excelEndpoint = EXCEL_ENDPOINT,
    filtersStateObject,
}) => {
    const t = useTranslation();
    const { IncludeNewKeywords: includeNewKeywords, IncludeTrendingKeywords: includeTrendingKeywords } =
        filtersStateObject;
    const { duration } = params;
    const is28d = duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS;
    const onSearchChange = (search) => onFilterChange(booleanSearchToObject(decodeURIComponent(search)));
    const fetcherService = DefaultFetchService.getInstance();
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const excelLink = `${excelEndpoint}?${fetcherService.requestParams(filtersStateObject)}`;
    const onBrandedNonBrandedChange = (item) => {
        if (!item) {
            onFilterChange({
                IncludeBranded: null,
                IncludeNoneBranded: null,
            });
            proNavigator.applyUpdateParams({ includeBranded: true, includeNoneBranded: true });
            return;
        }
        const { id } = item;
        const brandedValues = {
            IncludeBranded: id === EBrandedNonBrandedValues.IncludeBranded,
            IncludeNoneBranded: id === EBrandedNonBrandedValues.IncludeNoneBranded,
        };
        onFilterChange(brandedValues);
        const { IncludeBranded: includeBranded, IncludeNoneBranded: includeNoneBranded } = brandedValues;
        proNavigator.applyUpdateParams({ includeBranded, includeNoneBranded });
    };
    const onChangeNewlyDiscovered = (includeNewKeywords) => {
        const newlyDiscoveredParams = { IncludeNewKeywords: includeNewKeywords };
        onFilterChange(newlyDiscoveredParams);
        proNavigator.applyUpdateParams(newlyDiscoveredParams);
    };
    const onChangeTrending = (includeTrendingKeywords) => {
        const includeTrendingKeywordsParams = { IncludeTrendingKeywords: includeTrendingKeywords };
        onFilterChange(includeTrendingKeywordsParams);
        proNavigator.applyUpdateParams(includeTrendingKeywordsParams);
    };

    const displayNewKeywordsFilter = () => !is28d;
    const displayTrendingFilterNewPill = () => is28d;
    return (
        <div>
            <FiltersContainer>
                <BrandedNonBrandedFilter
                    tableFilters={filtersStateObject}
                    onBrandedNonBrandedChange={onBrandedNonBrandedChange}
                />
                {displayNewKeywordsFilter() ? (
                    <IncludeNewKeywordsFilterView
                        includeNewKeywords={includeNewKeywords}
                        onChangeNewlyDiscovered={onChangeNewlyDiscovered}
                    />
                ) : null}
                <IncludeTrendingKeywordsFilterView
                    includeTrendingKeywords={includeTrendingKeywords}
                    onChangeTrending={onChangeTrending}
                />
                {displayTrendingFilterNewPill() ? <span style={{ marginTop: 4 }}><Badge type="new" /></span> : null}
            </FiltersContainer>
            <SearchContainer>
                <BooleanSearchContainer>
                    <BooleanSearchUtilityWrapper onChange={onSearchChange} />
                </BooleanSearchContainer>
                <Right>
                    <FlexRow>
                        <DownloadButtonMenu
                            Excel={true}
                            downloadUrl={excelLink}
                            excelLocked={!downloadExcelPermitted}
                        />
                        <div>
                            <ColumnsPickerLite
                                {...getColumnsPickerLiteProps(tableColumns, onClickToggleColumns)}
                                withTooltip={true}
                                translations={{
                                    tooltip: t("workspace.sales.column.picker"),
                                    getSelectedAmountText: ({ selectedValue, totalValue }) =>
                                        t("common.columnsPicker.selectedAmount", {
                                            selected: selectedValue,
                                            total: totalValue,
                                        }),
                                    mandatoryField: t("common.columnsPicker.mandatoryField"),
                                    apply: t("common.apply"),
                                }}
                            />
                        </div>
                    </FlexRow>
                </Right>
            </SearchContainer>
        </div>
    );
};
